module.exports = __webpack_public_path__ + "img/will_h.d6167722.png";